export default {
  NewTask: 'New task',
};
